import RetailerUserList from './components/RetailerUserList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import get from 'lodash/get';
import values from 'lodash/values';
import {connect} from 'react-redux';

import {
  loadRetailer,
  loadAppUsersForRetailer,
  loadFilteredAppUsersForRetailer
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  const retailerId = props.retailerId;

  return {
    retailerId:retailerId,
    retailerName:get(state,['entities','companies',retailerId,'name']),
    appUsers:values(state.entities.appUsers).filter((u) => u.retailerId === retailerId)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadRetailer,
    loadAppUsersForRetailer,
    loadFilteredAppUsersForRetailer
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RetailerUserList));



// WEBPACK FOOTER //
// ./src/routes/RetailerUserList/index.js